"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Link = _interopRequireDefault(require("../../Link/Link"));
var _Svg = _interopRequireDefault(require("../../Svg/Svg"));
var Logo = function Logo(_ref) {
  var config = _ref.config,
    iconClassName = _ref.iconClassName;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "logo"
  }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: config.href,
    id: "logo"
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: config.icon.name,
    className: iconClassName,
    fill: config.icon.dark
  })));
};
Logo.propTypes = {
  config: _propTypes["default"].object,
  iconClassName: _propTypes["default"].string
};
var _default = exports["default"] = Logo;